import AppointmentTypeEntity from '../entities/AppointmentType.Entity';
import { apiGet } from '../support/helpers/ApiConnection.Helper';

export default function getAppointmentTypes(abortSignal: AbortSignal): Promise<Array<AppointmentTypeEntity>> {    
    return apiGet<Array<AppointmentTypeEntity>>('/appointment-type',abortSignal);
}
